import { alpha, PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { green, grey, unityGreen, unityGrey } from './colors';

export const action = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['action'] => {
  const hover = alpha(grey[300], 0.2);
  const selected = alpha(grey[300], 0.35);

  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          hover: alpha(unityGrey[300], 0.2),
          selected: alpha(unityGrey[300], 0.35),
          disabledBackground: alpha(unityGrey[300], 0.5),
          disabled: alpha(unityGrey[500], 0.6),
          menuSelected: unityGreen[50],
        }
      : {
          hover: alpha(unityGrey[300], 0.2),
          selected: alpha(unityGrey[300], 0.35),
          disabledBackground: alpha(unityGrey[300], 0.35),
          disabled: alpha(unityGrey[300], 0.5),
          menuSelected: unityGreen[800],
        };
  }

  return mode === 'light'
    ? {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.5),
        disabled: alpha(grey[500], 0.6),
        menuSelected: green[50],
      }
    : {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.35),
        disabled: alpha(grey[300], 0.5),
        menuSelected: green[800],
      };
};
